
export default {
  data: () => ({
    loading: false,
  }),
  mounted() {
    // this.$hyperUtility.paintSvg("loading", "#loading", "#320A64");
  },
  methods: {
    start() {
      this.loading = true;
    },
    finish() {
      this.loading = false;
    },
  },
};
